import { Component } from "@angular/core";
import { AbstractModalComponent } from "../modal/abstract-modal.component";

@Component({
  standalone: false,
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html'
})
export class MessageModalComponent extends AbstractModalComponent {
  title: string;
  message: string;
  confirmButton: string;
}
